export default __webpack_public_path__ + "static/foundation_b.768d25a7b0e37ac2a2f92647cde93ce2.svg";